<template>
<div v-if="withMarkup" :data-qa="dataQa" @click="onFocus">
    <slot/>

    <input
        ref="input"
        :type="keyboard"
        class="odr-input__with-markup"
        v-bind="$attrs"
        :value="value"
        v-on="$listeners"
        :style="{maxWidth: `${($attrs.placeholder.length + 1) * 10}px !important`}"/> <!-- Make <input/> wide enough to fully show the placeholder when no option is selected in the multiple-type combobox -->
</div>
<input v-else-if="keyboard"
       :type="keyboard"
       :data-qa="dataQa"
       v-bind="$attrs"
       :value="value"
       v-on="$listeners"/>
<textarea v-else
          :data-qa="dataQa"
          v-bind="$attrs"
          :value="value"
          v-on="$listeners"/>
</template>

<script>
export default {
    inheritAttrs: false,
    props: {
        keyboard: {},
        withMarkup: {},
        dataQa: {},
        value: {},
    },
    methods: {
        onFocus (event) {
            this.$refs.input.focus();
            this.$emit('click', event);
        },
    },
    watch: {
        value () {
            if (this.withMarkup) {
                this.$refs.input.style.setProperty('max-width', (((this.value ? this.value.length : this.$attrs.placeholder.length) + 1) * 10) + 'px', 'important');
            }
        },
    },
};
</script>
